export default __webpack_public_path__ + "65b273f647a2a6998af893c93dcda04e.svg";